import React, { useState } from 'react';
import { Dropdown } from '../../components/common';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useExperienceContent } from '../../hooks/use-server-content';
import { CxYmm } from '../../models/experiencefragments/cx-ymm';

interface Props {
    dropdownValueList: string[];
    isArticle: boolean;
}
export function isNumber(value: string) {
    const parsedValue = parseFloat(value);
    return !isNaN(parsedValue) && isFinite(parsedValue);
}
export const CxDropdown = (props: Props) => {
    const { year } = useParams<{
        year: string;
    }>();

    const { pathname } = useLocation();

    const history = useHistory();

    const currentPath = pathname.endsWith('/')
        ? pathname.slice(0, -1)
        : pathname;

    const [cxYmmContent] = useExperienceContent<CxYmm>(
        'img-cx-ymm',
        'cx-ymm',
        'img_cx_ymm'
    );

    function getYear() {
        if (isNumber(year)) {
            return year;
        } else if (isNumber(currentPath.slice(-4))) {
            return currentPath.slice(-4);
        } else {
            return props.dropdownValueList[0];
        }
    }

    const [yearValue, setYearValue] = useState(getYear());
    const dropdownModelYearValue =
        cxYmmContent?.dropdownModelYearName ?? 'Model Year';

    const createNewPathForArticle = (value: string) => {
        let newCreatedPath = '';
        if (isNumber(year)) {
            const [
                currentArticlePathOne,
                currentArticlePathTwo,
            ] = currentPath.split(year);
            const currentArticlePathOnePath = currentArticlePathOne.endsWith(
                '/'
            )
                ? currentArticlePathOne.slice(0, -1)
                : currentArticlePathOne;
            newCreatedPath =
                value === props.dropdownValueList[0]
                    ? `${currentArticlePathOnePath}${currentArticlePathTwo}`
                    : `${currentArticlePathOnePath}${currentArticlePathTwo}-${value}`;
        } else if (isNumber(currentPath.slice(-4))) {
            newCreatedPath =
                value === props.dropdownValueList[0]
                    ? `${currentPath.slice(0, -5)}`
                    : `${currentPath.slice(0, -5)}-${value}`;
        } else {
            newCreatedPath =
                value === props.dropdownValueList[0]
                    ? currentPath
                    : `${currentPath}-${value}`;
        }
        return newCreatedPath;
    };

    const createNewPathForNonArticle = (value: string) => {
        const [currentPathPartOne, currentPathPartTwo] = currentPath.split(
            year
        );
        return `${currentPathPartOne}${value}${currentPathPartTwo ?? ''}`;
    };

    const onYearChange = (value: string) => {
        setYearValue(value);
        let newCreatedPath = '';
        if (props.isArticle) {
            newCreatedPath = createNewPathForArticle(value);
        } else {
            newCreatedPath = createNewPathForNonArticle(value);
        }
        history.push(newCreatedPath);
    };

    return (
        <Dropdown
            options={props.dropdownValueList}
            label={dropdownModelYearValue}
            onChange={onYearChange}
            value={yearValue}
            id="year-dropdown"
            dataTestId="year-dropdown"
        />
    );
};

export default CxDropdown;
